import { render, staticRenderFns } from "./Dashboard-admin.vue?vue&type=template&id=a48a3d96&scoped=true&"
import script from "./Dashboard-admin.vue?vue&type=script&lang=js&"
export * from "./Dashboard-admin.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-admin.vue?vue&type=style&index=0&id=a48a3d96&scoped=true&lang=css&"
import style1 from "./Dashboard-admin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48a3d96",
  null
  
)

export default component.exports